import { useEffect } from "react";
import BlockText from "../block-content/block-text";
import styled from "styled-components";
import tw from "twin.macro";
import { Script } from "gatsby";

const YouVisitBlock = ({ props, site }) => {
  useEffect(() => {
    window.EmbedScript && window.EmbedScript.scanEmbeds();
  }, []);

  const youVisitBlock = props;
  const TextStyles = styled.div`
    a {
      ${tw`text-blue-500 cursor-pointer underline hover:text-blue-600`}
    }
    p {
      ${tw`text-sm md:text-lg mb-6`}
    }
  `;
  return (
    <section key={youVisitBlock._key} className="bg-blue-500 text-white">
      <div className="flex flex-wrap md:items-center">
        <div className="flex-shrink-0 w-full md:w-1/2 lg:w-7/12 h-96">
            <a
              href={`https://www.youvisit.com/#/vte/?data-platform=v&data-link-type=immersive&${site === "professional-advancement" || site === "graduate" ?
                  'data-inst=120392': 'data-inst=60231&data-loc=80132'}&data-stopid=${
                youVisitBlock.youVisit.stopId
                  ? youVisitBlock.youVisit.stopId
                  : "267290"
              }&data-image-width=100%&data-image-height=100%`}
            >
              {youVisitBlock.youVisit.linkLabel
                ? youVisitBlock.youVisit.linkLabel
                : "Launch Tour"}
            </a>
        </div>
        <div className="w-full md:w-1/2 lg:w-4/12 mx-auto px-4 py-4">
          <h2 className="tracking-tighter leading-none font-bold text-2xl md:text-3xl lg:text-4xl md:leading-none mb-2">
            {youVisitBlock.youVisit.title}
          </h2>
          <Script
            strategy="post-hydrate"
            src="https://www.youvisit.com/tour/Embed/js3"
          />
          <TextStyles>
            <BlockText blocks={youVisitBlock.youVisit._rawBody} />
          </TextStyles>
        </div>
      </div>
    </section>
  );
};

export default YouVisitBlock;
